import { debounce } from "../utilities/_throttleDebounce"
import { Rive } from "@rive-app/canvas"

export default function introModalController() {
    return {
        isOpen: false, // Start with modal open
        riveInstances: {}, // Match the riveController pattern of storing instances

        // Methods to control the modal
        open() {
						const self = this

            this.isOpen = true;
            // Disable scrolling when modal is open
            document.documentElement.style.overflow = 'hidden';

            // Show the canvas element with fade-in
            const canvas = document.getElementById('intro-owl');
            if (canvas) {
                // Set initial styles for fade-in
                canvas.style.display = 'block';
                canvas.style.opacity = '0';
                canvas.style.transition = 'opacity 0.6s ease-in-out';

                // Start fade-in after a tiny delay (allows for transition to work)
                setTimeout(() => {
                    canvas.style.opacity = '1';
                }, 50);
            }

						// Calulate overlay height
						//
						setTimeout(function() {
								self.calculateOverlayHeight()
						}, 100)
        },

        close() {
            this.isOpen = false;
            // Re-enable scrolling when modal is closed
            document.documentElement.style.overflow = '';
            // Save to local storage that user has seen the intro
            localStorage.setItem('introModalSeen', 'true');

            // Fade out the canvas before hiding it
            const canvas = document.getElementById('intro-owl');
            if (canvas) {
                // Set up the transition
                canvas.style.transition = 'opacity 0.4s ease-in-out';
                canvas.style.opacity = '0';

                // After animation completes, hide and clean up
                setTimeout(() => {
                    canvas.style.display = 'none';
                    // Clean up Rive instances
                    this.cleanupRiveInstances();
                }, 400); // Match the transition duration
            } else {
                // If no canvas, still clean up
                this.cleanupRiveInstances();
            }
        },

				calculateOverlayHeight() {
						this.$refs.introModalOverlay.style.height = ''

						if (this.$refs.introModal.scrollHeight > this.$refs.introModal.clientHeight) {
								this.$refs.introModalOverlay.style.height = this.$refs.introModal.scrollHeight + 'px'
						} else {
								this.$refs.introModalOverlay.style.height = this.$refs.introModal.clientHeight + 'px'
						}
				},

        cleanupRiveInstances() {
            // Clean up any existing Rive instances
            Object.values(this.riveInstances).forEach(instance => {
                try {
                    if (instance && typeof instance.cleanup === 'function') {
                        instance.cleanup();
                    }
                } catch (e) {
                    console.log('Error cleaning up Rive instance:', e);
                }
            });

            // Reset the instances object
            this.riveInstances = {};
        },

        initRiveCanvases() {
            // Initialize only the intro-owl canvas
            const canvas = document.getElementById('intro-owl');
            if (!canvas) return;

            // Make sure canvas is visible (but may still be fading in)
            if (canvas.style.display !== 'block') {
                canvas.style.display = 'block';
            }

            const fileURL = canvas.dataset.url;
            const canvasID = canvas.id;

            // Skip if we already have an instance for this canvas
            if (this.riveInstances[canvasID]) return;

            if (fileURL) {
                // Follow exact pattern from riveController
                const riveInstance = new Rive({
                    src: fileURL,
                    canvas: canvas,
                    autoplay: true,
                    clearCanvas: false,
                    background: "transparent",
                    stateMachines: ["State Machine 1"],
                    onLoad: () => {
                        riveInstance.resizeDrawingSurfaceToCanvas();
                        this.riveInstances[canvasID] = riveInstance;
                    },
                });
            } else {
                console.error(`No Rive URL provided for canvas ID "${canvasID}"`);
            }
        },

        init() {
						const self = this

            // Check if user has already seen the intro
            const hasSeenIntro = localStorage.getItem('introModalSeen') === 'true';

            // Only show on first visit
            if (hasSeenIntro) {
                this.isOpen = false;

                // Hide the canvas element initially if modal is closed
                const canvas = document.getElementById('intro-owl');
                if (canvas) {
                    canvas.style.display = 'none';
                    canvas.style.opacity = '0';
                    // Add transition property for later use
                    canvas.style.transition = 'opacity 0.6s ease-in-out';
                }
            } else {
                // If showing on first visit, prepare the canvas for fade-in
                const canvas = document.getElementById('intro-owl');
                if (canvas) {
                    // Start transparent
                    canvas.style.opacity = '0';
                    canvas.style.transition = 'opacity 0.6s ease-in-out';

                    // Allow time for DOM to be ready, then fade in
                    setTimeout(() => {
                        canvas.style.opacity = '1';
                    }, 500);
                }

								setTimeout(function() {
										// Show the modal
										self.open()
								}, 100)
            }

            // Initialize Rive when modal becomes visible
            this.$watch('isOpen', (value) => {
                if (value) {
                    // Small delay to ensure DOM is ready
                    setTimeout(() => {
                        this.initRiveCanvases();
                    }, 100);
                }
                // Note: Cleanup is now handled in the close() method with fade-out
            });

            // Listen for "How to play" button clicks
            this.$watch('$store.introModal.requestOpen', (value) => {
                if (value) {
                    this.open();
                    // Reset the flag
                    this.$store.introModal.requestOpen = false;
                }
            });

						// Handle modal overlay
						//
						window.addEventListener('resize', debounce(function() {
								self.calculateOverlayHeight()
						}, 100))
        }
    };
}
